import React from "react";
const Suggestions = () => {
    return(
        <div>
                        <h6 className="mb-3">Weekly Paragraph by Content Manager</h6>
        <div className="wrap-suggestion">
                <div className="img-bx">
                    <img src="/assets/images/user-profile.svg" />
                </div>
                <div className="wrap-suggestion-content">
                    <div className="user-details">
                    <h6>Jonathan Levi</h6>
                    <p>Enrolled 2016 B.Tech, Computer Science and Engineering August 28,2022</p>
                    </div>
                    <div className="content-para">
                        <p>But I must explain to you how all this mistaken idea of reprobating pleasure and extolling pain arose. To do so, I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Suggestions